import { render, staticRenderFns } from "./ColumnForm.vue?vue&type=template&id=2af8d9bf&"
import script from "./ColumnForm.vue?vue&type=script&lang=ts&"
export * from "./ColumnForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports